import { Box, IconButton, Typography } from '@material-ui/core'
import { FunctionComponent, useState } from 'react'
//@ts-ignore
import { MainContainer } from 'components/page/containers/MainContainer'
//@ts-ignore
import { useTheme } from 'styled-components'
import { usePartnerManagement } from 'hooks/use-partner-management/usePartnerManagement'
import { UserAdmin } from '../../../../common/types/admin.types'
import { useAuth } from 'pages/auth/hooks/useAuth'
import { ArrowBack } from '@material-ui/icons'
import { useHistory, useParams } from 'react-router-dom'
import { usePartnerProfile } from 'pages/profile/hooks/usePartnerProfile'
import { Loader } from 'components/core/loader'
import { usePartnerApi } from '../../../../hooks/use-partner-api/usePartnerApi'
import ViewGroupItem from './ViewGroupItem'
import { useFetchPartnerAdmins } from './hooks/useFetchPartnerAdmins'
import { StyledBorderLine, StyledGroupsBox, StyledInText } from './style'

const { ThemeProvider } = require('@livechat/ui-kit')

interface ViewPartnerAdminsGroupsProps {}
export const ViewAdminGroupsPage: FunctionComponent<ViewPartnerAdminsGroupsProps> = () => {
  const theme = useTheme()
  const history = useHistory()

  const color1 = theme.colors.accent
  const color2 = theme.colors.accent1

  const { userId } = useParams<{ userId: string }>()
  const [role, setRole] = useState<any>()
  const [isLoading, setIsLoading] = useState(true)

  const { backendUser } = useAuth()
  const { company } = usePartnerProfile()

  const { partnerAdminUsers: admins, getAdminUsersByPartnerId } = usePartnerManagement()

  const { partnerAdminList } = useFetchPartnerAdmins()

  const { fetchAdminUserGroupsByRoleId } = usePartnerApi()
  // const [userGroup, setUserGroup] = useState<UserGroup>()
  let [user, setUser] = useState<UserAdmin>()

  //TODO: get user data
  if (!admins.length) {
    getAdminUsersByPartnerId()
  }

  const currentUser = partnerAdminList?.data?.find(user => user.id === userId)

  // Get role from user data
  fetchAdminUserGroupsByRoleId(currentUser?.roleId).then(res => {
    setRole(res)
  })

  if (isLoading) {
    if (currentUser && role) {
      setIsLoading(false)
    }
  }

  return (
    <ThemeProvider theme={{}}>
      {isLoading && <Loader />}

      {!isLoading && (
        <MainContainer
          stickTopBar
          title={`${currentUser?.firstname} Groups`}
          user={backendUser}
          showAvatar
          hideFooter={false}
        >
          <Box display="flex" justifyContent="center" alignItems="center" width="100%" marginTop="6em">
            <StyledGroupsBox id="constrainer">
              <Box>
                <IconButton>
                  <ArrowBack style={{ color: theme.colors.accent1 }} onClick={() => history.goBack()} />
                  <Box>
                    <Typography variant="h5">
                      <Box fontWeight="bold" color={theme.colors.accent1} ml=".50em">
                        List of Admin Group
                      </Box>
                    </Typography>
                  </Box>
                </IconButton>
                <StyledBorderLine />
              </Box>
              <StyledInText>
                <Box
                  style={{
                    backgroundColor: theme.colors.supplementary1
                  }}
                >
                  {[
                    {
                      label: '',
                      value: `${role && role.name}`
                    }
                  ].map(userData => (
                    <ViewGroupItem {...userData} color1={color1} color2={color2}></ViewGroupItem>
                  ))}
                </Box>
              </StyledInText>
            </StyledGroupsBox>
          </Box>
        </MainContainer>
      )}
    </ThemeProvider>
  )
}
